import { render, staticRenderFns } from "./SettlementSepaDownloadIcon.vue?vue&type=template&id=7ac56ed0&scoped=true&"
import script from "./SettlementSepaDownloadIcon.vue?vue&type=script&lang=js&"
export * from "./SettlementSepaDownloadIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac56ed0",
  null
  
)

export default component.exports